var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 24,
    viewBox: "0 0 31 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.59375 12C1.59375 12 6.59375 2 15.3438 2C24.0938 2 29.0938 12 29.0938 12C29.0938 12 24.0938 22 15.3438 22C6.59375 22 1.59375 12 1.59375 12Z",
    stroke: "#1374D5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0938 12C19.0938 14.0711 17.4148 15.75 15.3438 15.75C13.2727 15.75 11.5938 14.0711 11.5938 12C11.5938 9.92893 13.2727 8.25 15.3438 8.25C17.4148 8.25 19.0938 9.92893 19.0938 12Z",
    stroke: "#1374D5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye-icon.5f12de7f393bdc5902ffebaa26e06777.svg";
export { ForwardRef as ReactComponent };